export default "__VITE_ASSET__CwGZnihE__"